export default {
    "en": {
        "image": {
            "success": "udalo sie"
        }
    }
}
//TODO to generate this file (to set this directory fork below repo and remove base_path() from line 88 in src/Commands/GenerateInclude.php)
// install and use https://github.com/martinlindhe/laravel-vue-i18n-generator
// copy file src/config/vue-i18n-generator.php and paste to config/ and set correct directories

